import React from 'react';
import InfoSection from '../../InfoSection/InfoSection.jsx';

const StoreItemIncompatibleView = ({ requestToQuote, onRequestQuotation, onRequestDemo, incompatibleAdditionalNotes, containerStyle, onRequestActivation }) => (
  <InfoSection
    gravity="warning"
    title={incompatibleAdditionalNotes || "storeItemNotCompatible"}
    subtitle="storeItemNotCompatibleDescription"
    containerStyle={{ marginLeft: 30, marginRight: 30, textAlign: 'center', ...containerStyle }}
    titleStyle={{ textAlign: 'center' }}
    headerStyle={{ justifyContent: 'center' }}
  />
);
export default StoreItemIncompatibleView;
